export default state => ({
  ...state,
  activeDeviceTab: 'processes',
  activeDeviceInitialized: false,
  deviceUsers: [],
  allDeviceProcessesLoaded: false,
})
